import styled, { css } from "styled-components";
import device from 'utils/device'

export default styled.div`
  ${({ theme, height, spacing }) => css`
  @media ${device.laptop} { 
    position: relative;
      height: 100%;


      height: ${height ?? '800px'};
      max-height: ${`calc(100vh - ${spacing ?? '300px'})`};
      overflow-y: auto;

      scrollbar-width: thin;
      scrollbar-color: #E3E3E3 transparent;

      overflow: overlay !important;

      ::-webkit-scrollbar {
        width: 16px;
        height: 16px;
        background: transparent;
      }

      ::-webkit-scrollbar-track-piece  {
        background: transparent;
      }

      ::-webkit-scrollbar-thumb:vertical {
        background: linear-gradient(to left, #E3E3E3 4px, transparent 0%);
        border-radius: 10px;
      }

      ::-webkit-scrollbar-thumb:horizontal {
        background: linear-gradient(to top, #E3E3E3 4px, transparent 0%);
        border-radius: 10px;
      }

      ::-webkit-scrollbar-thumb:hover {
        background: #E3E3E3;
      }
    }
  `}
`;
